"use client";

import { PopoverContent as HeroPopoverContent } from "@heroui/react";
import { cn } from "../../lib/utils";

export const PopoverContent = ({
  className,
  ...props
}: { className?: string } & React.ComponentProps<typeof HeroPopoverContent>) => {
  return <HeroPopoverContent className={cn(className)} {...props} />;
};
